import { FC } from "react";

export const CheckedCircle: FC<
  React.PropsWithChildren<{
    color?: string;
    backgroundColor?: string;
  }>
> = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill={props.backgroundColor || "#fff"} />
      <path
        d="M17.33333 8L9.92225 16L6.66667 12.4"
        stroke={props.color || "#5C5757"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
